import React from 'react'
import Verify from '../../components/verify/Verify'

function Verification() {
  return (
    <div>
      <Verify/>
    </div>
  )
}

export default Verification
